var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('article',{staticClass:"site-container",class:{ 'site-container-lg': _vm.large, 'site-container-xl': _vm.xl }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }